module.exports = __webpack_public_path__ + "static/media/typeb1.0fb06c8f.jpg";